import React from 'react';
import { NotificationProvider as Provider } from '../contexts/NotificationContext';

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <Provider>{children}</Provider>;
};

export default NotificationProvider;
